import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';

import SectionDetail from '../../components/section/SectionDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { editSection } from '../../redux/section/section_actions';

class SectionEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.sectionDetail = undefined;
  }

  onSaveHandler() {
    const editedSection = this.sectionDetail.getWrappedInstance().getWrappedInstance().getSectionData();
    this.props.editSection({ ...editedSection, id: this.props.section.id });
  }

  render() {
    const { isEditing, errorMessage, editSection, section, building, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit section')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SectionDetail
            isShowArea={true}
            isShowWWR={true}
            section={section}
            building={building}
            ref={ref => (this.sectionDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="section-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.section.errorMessage,
  isEditing: state.section.isEditing,
});

const mapDispatchToProps = dispatch => ({
  editSection: ({ id, name, envelop_id, description }) =>
    defaultRejectHandler(
      dispatch(editSection(id, name, envelop_id, description)),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SectionEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/section/SectionEditModal.js